// Vendor imports
const qs = require('qs')
// Client lib imports
const globalPageContext = require('client/lib/business-events/page-context')
// Client V2 common imports
const { render } = require('client-v2/common/client')
const clientV1Bridge = require('client-v2/common/client-v1-bridge')
const { slideDidBecomeVisible } = require('client-v2/common/containers/article-profile/state/slide-actions')
const { showSignup } = require('client-v2/common/containers/auth-modal/actions')
// Entry imports
const rootFactory = require('./components/root').factory
const configureStore = require('./state/store')

render(configureStore, rootFactory)

const { articleProfile, user } = app.store.getState()

globalPageContext.setPageContext({
  pageName: 'article.card'
})
app.store.dispatch(slideDidBecomeVisible({
  slide: articleProfile
}))

const { action } = qs.parse(location.search, { ignoreQueryPrefix: true })
if (action) {
  const { article } = articleProfile
  if (action === 'add') {
    if (user.loggedIn) {
      clientV1Bridge.showMixSelectModal({ article })
    } else {
      app.store.dispatch(showSignup())
    }
  }
  if (action === 'share') {
    clientV1Bridge.showArticleShareModal({ article })
  }
}
